import QuestionsSection from './ui/questionSection/QuestionsSection';

export default QuestionsSection;